import AnalyticsMilkByDay from './AnalyticsMilkByDay';

export default AnalyticsMilkByDay